// In sviluppo locale, usa URL completo; in produzione usa percorso relativo
const defaultApiBaseUrl = process.env.NODE_ENV === 'production'
  ? '/api'
  : 'http://localhost:3001/api';

export const API_BASE_URL = (process.env.REACT_APP_API_URL || defaultApiBaseUrl)
  .replace(/\/+$/, '');

console.log('API Base URL:', API_BASE_URL);

const parseErrorResponse = async (response) => {
  const contentType = response.headers.get('content-type');
  if (contentType && contentType.includes('application/json')) {
    const error = await response.json().catch(() => ({ error: 'Errore sconosciuto' }));
    throw new Error(error.error || `HTTP error! status: ${response.status}`);
  }

  throw new Error(`HTTP error! status: ${response.status}`);
};

// Helper per gestire risposte fetch
const handleResponse = async (response) => {
  if (!response.ok) {
    return parseErrorResponse(response);
  }

  const contentType = response.headers.get('content-type');
  if (contentType && contentType.includes('application/json')) {
    return response.json();
  }

  throw new Error('Risposta non JSON ricevuta dal server');
};

const buildAuthenticatedHeaders = (headers = {}, addJsonContentType = true) => {
  const token = localStorage.getItem('auth_token');
  const nextHeaders = { ...headers };

  if (addJsonContentType && !nextHeaders['Content-Type'] && !nextHeaders['content-type']) {
    nextHeaders['Content-Type'] = 'application/json';
  }

  if (token) {
    nextHeaders.Authorization = `Bearer ${token}`;
  }

  return nextHeaders;
};

// Helper per richieste autenticate
const authenticatedFetch = async (url, options = {}) => {
  const response = await fetch(url, {
    ...options,
    headers: buildAuthenticatedHeaders(options.headers, true)
  });

  return handleResponse(response);
};

export const authenticatedFetchRaw = async (pathOrUrl, options = {}) => {
  const url = pathOrUrl.startsWith('http')
    ? pathOrUrl
    : `${API_BASE_URL}${pathOrUrl.startsWith('/') ? pathOrUrl : `/${pathOrUrl}`}`;

  const response = await fetch(url, {
    ...options,
    headers: buildAuthenticatedHeaders(options.headers, false)
  });

  if (!response.ok) {
    return parseErrorResponse(response);
  }

  return response;
};

// API Auth
export const authAPI = {
  register: async (email, password) => {
    try {
      const response = await fetch(`${API_BASE_URL}/auth/register`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password })
      });
      const data = await handleResponse(response);
      if (data.token) {
        localStorage.setItem('auth_token', data.token);
      }
      return data;
    } catch (error) {
      console.error('Errore registrazione:', error);
      if (error.message === 'Failed to fetch') {
        throw new Error('Impossibile connettersi al server. Verifica che il backend sia in esecuzione su http://localhost:3001');
      }
      throw error;
    }
  },

  login: async (email, password) => {
    try {
      const response = await fetch(`${API_BASE_URL}/auth/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password })
      });
      const data = await handleResponse(response);
      if (data.token) {
        localStorage.setItem('auth_token', data.token);
      }
      return data;
    } catch (error) {
      console.error('Errore login:', error);
      throw new Error(error.message || 'Errore di connessione al server. Verifica che il backend sia in esecuzione.');
    }
  },

  logout: () => {
    localStorage.removeItem('auth_token');
  },

  getCurrentUser: async () => authenticatedFetch(`${API_BASE_URL}/auth/me`),

  isAuthenticated: () => !!localStorage.getItem('auth_token')
};

export const settingsAPI = {
  getSettings: async () => authenticatedFetch(`${API_BASE_URL}/settings`),

  saveSettings: async (settings) => authenticatedFetch(`${API_BASE_URL}/settings`, {
    method: 'PUT',
    body: JSON.stringify(settings)
  }),

  uploadLogo: async (payload) => authenticatedFetch(`${API_BASE_URL}/settings/logo`, {
    method: 'POST',
    body: JSON.stringify(payload)
  }),

  removeLogo: async () => authenticatedFetch(`${API_BASE_URL}/settings/logo`, {
    method: 'DELETE'
  }),

  resetSettings: async () => authenticatedFetch(`${API_BASE_URL}/settings/reset`, {
    method: 'POST'
  })
};
